import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const axiosWithCredentials = axios.create({
  withCredentials: true,
});

export const ADMIN_PANEL_TABS = [
  { id: 'vendedores', icon: '👥', label: 'Vendedores' },
  { id: 'leads', icon: '📄', label: 'Leads' },
  { id: 'agendamentos', icon: '📅', label: 'Agendamentos' },
  { id: 'uploads', icon: '📁', label: 'Arquivos Upload' },
];

export const adminPanelApiClient = axiosWithCredentials;

export const fetchAdminPanelData = async () => {
  const [vendedoresRes, leadsRes, allLeadsRes, contactsRes] = await Promise.all([
    axiosWithCredentials.get(`${API}/vendedores`),
    axiosWithCredentials.get(`${API}/admin/vendedores/metrics`),
    axiosWithCredentials.get(`${API}/admin/leads`),
    axiosWithCredentials.get(`${API}/admin/contacts`),
  ]);

  return {
    vendedores: vendedoresRes.data,
    leadsMetrics: leadsRes.data,
    allLeads: allLeadsRes.data,
    contacts: contactsRes.data,
  };
};
